function buyNow( button ) {
  const variantId = button.getAttribute('data-variant-id');

  if ( !variantId ) {
    console.error('Variant ID not found');return;
  }

  fetch('/cart/add.js', {
    method : 'POST',
    headers: {'Content-Type': 'application/json'},
    body   : JSON.stringify({
      id      : variantId,
      quantity: 1,
    }),
  })
    .then(( res ) => {
      if ( !res.ok ) {
        throw new Error('Add to cart failed');
      }
      window.location.href = '/checkout';
    })
    .catch(( err ) => {
      console.error(err);});
} 